import React, { Component } from 'react';
import { object, bool } from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { event as EventIcon } from 'common/svg/icons';
import { Card, BannerComponent } from '../';
import './index.css';

// TODO: refactor to be more reusable
class SectionList extends Component {
  static propTypes = {
    data: object.isRequired,
    browser: object.isRequired,
    scroll: bool,
  };

  static defaultProps = {
    scroll: false,
  };

  constructor(props) {
    super(props);
    this.myRef = React.createRef(); // Create a ref object
  }

  componentDidMount() {
    if (this.myRef && this.myRef.current && this.props.scroll) {
      this.scrollToMyRef();
    }
  }

  scrollToMyRef = () => {
    const { browser } = this.props;
    // use window scroll on mobile
    const target = browser.is.mobile
      ? window
      : document.querySelector('.field-wrapper__aside__content');
    if (target) {
      target.scroll(0, this.myRef.current.offsetTop - 10);
    }
  };

  render() {
    // data needs to be grouped before passed in
    const { data = {} } = this.props;

    if (Object.keys(data).length === 0) {
      return null;
    }

    return (
      <div className="sectionlist">
        {Object.entries(data).map(([key, value]) =>
          this.renderSection(moment(key).format('MMMM D'), value)
        )}
      </div>
    );
  }

  renderSection = (sectionTitle, cards) => (
    <div
      key={sectionTitle}
      ref={sectionTitle === moment().format('MMMM D') && this.myRef}
    >
      <p className="sectionlist__title">{sectionTitle}</p>
      {cards.length > 0 ? (
        <ul className="cardlist">{cards.map(this.renderCard)}</ul>
      ) : (
        <ul className="cardlist">
          <BannerComponent
            message="There are no activities planned for today."
            theme={['offline-short', 'bold']}
            leftIcon={<EventIcon />}
          />
        </ul>
      )}
    </div>
  );

  renderCard = (card, idx) => {
    const {
      link,
      action,
      top,
      footer,
      title,
      subtitle,
      content,
      status,
    } = card;
    return (
      <li key={idx} className={'cardlist__item'}>
        <Card
          link={link}
          action={action}
          top={top}
          footer={footer && <strong className={'text--fade'}>{footer}</strong>}
        >
          <h3 className={'cardlist__title'}>{title}</h3>
          {status && (
            <p className="cardlist__status">
              {status.text}{' '}
              <span style={{ backgroundColor: status.backgroundColor }} />
            </p>
          )}
          {subtitle && <h5 className={'cardlist__subtitle'}>{subtitle}</h5>}
          {content}
        </Card>
      </li>
    );
  };
}

const mapState = ({ browser }) => ({ browser });

export default connect(mapState)(SectionList);



// WEBPACK FOOTER //
// ./src/common/components/SectionList/index.js